import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { DEFAULT_USER, IS_DEMO } from 'config.js';
import { messages } from 'lang/messages/messages';
import { actions } from 'react-table';

const initialState = {
    accepetedArticlelist: {},
    rejectedArticleList: {},
    withdrawArticleList: {},
    assignReviewerList: {},
    reviewStatus: {},
    notification: {},
    reviwerDropdownlist: {},
    withdraw: {}

};

const CompltedArticleSlice = createSlice({
    name: 'articles',
    initialState,
    reducers: {
        setAccepetedArticleList(state, action) {
            state.accepetedArticlelist = action.payload;
        },
        setRejectedArticleList(state, action) {
            state.rejectedArticleList = action.payload;
        },
        setWithdrawArticle(state, action) {
            state.withdrawArticleList = action.payload;
        },
        setReviewStatus(state, action) {
            state.reviewStatus = action.payload;
        },
        setAssignedReviewerList(state, action) {
            state.assignReviewerList = action.payload;
        },
        setToast(state, action) {
            state.notification = action.payload;
        },
        setReviewerDropdownList(state, action) {
            state.reviwerDropdownlist = action.payload
        },
        setWithdraw(state, action) {
            state.withdraw = action.payload
        }

    },
});



export const AccepetedArticleListApi = (tokendata, page, limit, search, journalId) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=completed_accept&journal_uuid=${journalId}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setAccepetedArticleList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}
export const RejectedArticleListApi = (tokendata, page, limit, search, journalId) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=completed_reject&journal_uuid=${journalId}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setRejectedArticleList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}
export const WithdrawArticleListApi = (tokendata, page, limit, search, journalId) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitManuScriptList?page=${page}&limit=${limit}&search=${search}&type=completed_withdraw&journal_uuid=${journalId}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setWithdrawArticle(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}

export const ReviewStatusListApi = (tokendata, uuid) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/articleReviewerList/${uuid}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setReviewStatus(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            // dispatch(setToast({
            //     status: false, message: err?.response?.data?.message
            // }))

        })

}
export const AssignedReviewersListApi = (tokendata, uuid) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/submitmanuscript/assignReviewerList/${uuid}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setAssignedReviewerList(res?.data?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            // dispatch(setToast({
            //     status: false, message: err?.response?.data?.message
            // }))

        })

}

export const ReviewersDropdownListApi = (tokendata, uuid) => async (dispatch) => {

    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/ats/reviewerListByClassification/${uuid}`,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            dispatch(setReviewerDropdownList(res?.data))
            // dispatch(setToast({
            //     status: true, message: res?.data?.message
            // }))


        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            // dispatch(setToast({
            //     status: false, message: err?.response?.data?.message
            // }))

        })

}
export const InviteReviwerArticleListApi = (tokendata, values) => async (dispatch) => {

    const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptReviewerAssign`, values,
        {
            headers: {
                "authorization": ` Bearer ${tokendata}`
            }
        }
    )
        .then((res) => {
            console.log(res, "fsdfff")
            // dispatch(setRejectedArticleList(res?.data?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err?.response, "wddss");
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))

        })

}

export const WithdrawArticleApi = (uuid, tokendata,payload) => async (dispatch) => {
    const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/ats/manuscriptwithdraw/${uuid}`, payload,
        {
            headers: {
                "Authorization": ` Bearer ${tokendata}`
            },

        }
    )
        .then((res) => {
            console.log(res,"reddfdfd")
            dispatch(setWithdraw(res?.data))
            dispatch(setToast({
                status: true, message: res?.data?.message
            }))
        })
        .catch((err) => {
            console.log(err, "er23ghg2rf")
            dispatch(setToast({
                status: false, message: err?.response?.data?.message
            }))
        })

}


export const { setAccepetedArticleList, setToast, setReviewStatus, setAssignedReviewerList, setRejectedArticleList, setWithdrawArticle, setReviewerDropdownList, setWithdraw } = CompltedArticleSlice.actions;
const CompletedArticleReducer = CompltedArticleSlice.reducer;

export default CompletedArticleReducer;
